import {
  ACTIVATE_CHANNEL_PIN_INIT,
  ACTIVATE_CHANNEL_PIN_SUCCESS,
  ACTIVATE_CHANNEL_PIN_ERROR,
  ACTIVATE_CHANNEL_PIN_CLEAR,
} from '../../actions/channelBlocker/constants';

const initialState = {
  inProgress: false,
  success: false,
  error: null,
  data: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case ACTIVATE_CHANNEL_PIN_INIT: {
      return {
        ...initialState,
        inProgress: true,
      };
    }
    case ACTIVATE_CHANNEL_PIN_SUCCESS: {
      return {
        inProgress: false,
        success: true,
        error: null,
        data: action.payload,
      };
    }
    case ACTIVATE_CHANNEL_PIN_ERROR: {
      return {
        inProgress: false,
        success: false,
        error: action.error,
        data: null,
      };
    }
    case ACTIVATE_CHANNEL_PIN_CLEAR: {
      return initialState;
    }
    default:
      return state;
  }
};
